var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("Spinner")
        : _vm.prospect
        ? _c(
            "div",
            [
              _c("div", { staticClass: "default-prospect-header" }, [
                _c(
                  "div",
                  { staticClass: "header-name" },
                  [
                    _c("h2", { staticClass: "grand-size-text prospect" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.prospect.name) +
                          " " +
                          _vm._s(_vm.prospect.lastName) +
                          " "
                      ),
                    ]),
                    _vm.prospect.status
                      ? _c(
                          "span",
                          {
                            staticClass: "current-status",
                            attrs: { id: "prospectCurrentStatus" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    `prospectStatus.${_vm.prospect.status}`
                                  )
                                ) +
                                " "
                            ),
                            _c("i", { staticClass: "fas fa-chevron-right" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    `prospectSubStatus.${_vm.prospect.subStatus}`
                                  )
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.prospect.brokerId
                      ? _c(
                          "b-button",
                          {
                            staticClass:
                              "is-button-secondary ml-2 is-small is-rounded is-fullwidth-mobile",
                            attrs: { id: `prospect-${_vm.prospect._id}` },
                            on: {
                              click: function ($event) {
                                return _vm.goToSingleBrokerView(
                                  _vm.prospect.brokerId
                                )
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("accessBroker")) + " ")]
                        )
                      : _vm._e(),
                    _c(
                      "b-button",
                      {
                        staticClass:
                          "is-button-secondary ml-2 is-small is-rounded is-pulled-right",
                        attrs: { id: "return-btn" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.go(-1)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("back")) + " ")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "card-item prospect-info mb-3" },
                [
                  _c(
                    "div",
                    { staticClass: "prospect-content-buttons" },
                    [
                      _c(
                        "b-tabs",
                        {
                          attrs: { expanded: "" },
                          model: {
                            value: _vm.selectedContent,
                            callback: function ($$v) {
                              _vm.selectedContent = $$v
                            },
                            expression: "selectedContent",
                          },
                        },
                        _vm._l(_vm.contentButtons, function (value, content) {
                          return _c("b-tab-item", {
                            key: content,
                            attrs: {
                              id: `${value}-data`,
                              label: _vm.$t(value),
                              value: `${content}-data`,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.selectedContent === "prospect-data"
                    ? _c("ProspectData", { attrs: { prospect: _vm.prospect } })
                    : _vm._e(),
                  _vm.selectedContent === "simulations-data"
                    ? _c("SimulationsData", {
                        attrs: { simulations: _vm.simulations },
                        scopedSlots: _vm._u(
                          [
                            _vm.showSimulationButton
                              ? {
                                  key: "simulation-header",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "call-to-action mx-1 has-text-centered",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "is-6-widescreen is-full-desktop card-item is-shadowless has-background-light is-flex is-flex-wrap-wrap is-justify-content-space-between px-5 py-4",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "is-size-6 my-1 has-text-weight-medium pr-6",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("simulatorLead")
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      staticClass:
                                                        "is-button-primary is-small is-rounded my-0",
                                                      attrs: {
                                                        id: "add-simulation-button",
                                                        tag: "a",
                                                        "icon-left":
                                                          "fa-solid fa-plus",
                                                        size: "is-small",
                                                        href: _vm.buildSimulatorFrontUrl(),
                                                        target: "_blank",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t("simulator")
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                          ],
                          null,
                          true
                        ),
                      })
                    : _vm._e(),
                  _vm.selectedContent === "documents-data"
                    ? _c("DocumentForm", {
                        attrs: {
                          id: "prospect-contact-data",
                          "prospect-information-props": _vm.prospect,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c("InteractionsHistory", {
                attrs: {
                  fields: _vm.interactionFields,
                  interactions: _vm.prospect.interactions,
                  "is-loading": _vm.loadingInteractions,
                },
                on: {
                  "update:fields": function ($event) {
                    _vm.interactionFields = $event
                  },
                  "update:isLoading": function ($event) {
                    _vm.loadingInteractions = $event
                  },
                  "update:is-loading": function ($event) {
                    _vm.loadingInteractions = $event
                  },
                  "create-new-interaction": function ($event) {
                    return _vm.createNewInteraction($event)
                  },
                  "load-interactions": function ($event) {
                    return _vm.loadProspect()
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }